import { ReviewType } from '@/types/github';

/**
 * The review form's choices, in its order. Approving and requesting changes need a pull request
 * someone else wrote.
 */
export const PR_V2_REVIEW_OPTIONS = [
  { type: ReviewType.APPROVE, label: 'Approve', needsOtherAuthor: true },
  { type: ReviewType.COMMENT, label: 'Comment', needsOtherAuthor: false },
  { type: ReviewType.REQUEST_CHANGES, label: 'Request changes', needsOtherAuthor: true },
] as const;
